// Auto-generated icons.js
// This file is generated by generate-icons.sh script
import arrow from '../icons/arrow.svg?react'
import arrow_circle from '../icons/arrow_circle.svg?react'
import arrow_r from '../icons/arrow_r.svg?react'
import assistant from '../icons/assistant.svg?react'
import bed from '../icons/bed.svg?react'
import burger from '../icons/burger.svg?react'
import calendar from '../icons/calendar.svg?react'
import calendar_check from '../icons/calendar_check.svg?react'
import camera from '../icons/camera.svg?react'
import capacity from '../icons/capacity.svg?react'
import chair from '../icons/chair.svg?react'
import chat from '../icons/chat.svg?react'
import check from '../icons/check.svg?react'
import checked from '../icons/checked.svg?react'
import chef from '../icons/chef.svg?react'
import chevron_down from '../icons/chevron_down.svg?react'
import circle_star from '../icons/circle_star.svg?react'
import circle_star_inverted from '../icons/circle_star_inverted.svg?react'
import clock from '../icons/clock.svg?react'
import close from '../icons/close.svg?react'
import compass from '../icons/compass.svg?react'
import cross from '../icons/cross.svg?react'
import cursor from '../icons/cursor.svg?react'
import cutlery from '../icons/cutlery.svg?react'
import dish from '../icons/dish.svg?react'
import district from '../icons/district.svg?react'
import door from '../icons/door.svg?react'
import download from '../icons/download.svg?react'
import drink from '../icons/drink.svg?react'
import email from '../icons/email.svg?react'
import facebook from '../icons/facebook.svg?react'
import flag from '../icons/flag.svg?react'
import geolocation from '../icons/geolocation.svg?react'
import heart from '../icons/heart.svg?react'
import heart_brown from '../icons/heart_brown.svg?react'
import heart_dark from '../icons/heart_dark.svg?react'
import heart_solid from '../icons/heart_solid.svg?react'
import home from '../icons/home.svg?react'
import instagram from '../icons/instagram.svg?react'
import leaf from '../icons/leaf.svg?react'
import linkedin from '../icons/linkedin.svg?react'
import man from '../icons/man.svg?react'
import map_marker from '../icons/map_marker.svg?react'
import map_marker_active from '../icons/map_marker_active.svg?react'
import marker from '../icons/marker.svg?react'
import mask from '../icons/mask.svg?react'
import minus from '../icons/minus.svg?react'
import monaco_flag_mini from '../icons/monaco_flag_mini.svg?react'
import moon_half from '../icons/moon_half.svg?react'
import news from '../icons/news.svg?react'
import no_pmr from '../icons/no_pmr.svg?react'
import phone from '../icons/phone.svg?react'
import plus from '../icons/plus.svg?react'
import plus_map from '../icons/plus_map.svg?react'
import pmr from '../icons/pmr.svg?react'
import podium from '../icons/podium.svg?react'
import presentation from '../icons/presentation.svg?react'
import search from '../icons/search.svg?react'
import share from '../icons/share.svg?react'
import star from '../icons/star.svg?react'
import star_michelin from '../icons/star_michelin.svg?react'
import sun from '../icons/sun.svg?react'
import sun_half from '../icons/sun_half.svg?react'
import terrace from '../icons/terrace.svg?react'
import ticket from '../icons/ticket.svg?react'
import tiktok from '../icons/tiktok.svg?react'
import weather_01d from '../icons/weather/01d.svg?react'
import weather_01n from '../icons/weather/01n.svg?react'
import weather_02d from '../icons/weather/02d.svg?react'
import weather_02n from '../icons/weather/02n.svg?react'
import weather_03d from '../icons/weather/03d.svg?react'
import weather_03n from '../icons/weather/03n.svg?react'
import weather_04d from '../icons/weather/04d.svg?react'
import weather_04n from '../icons/weather/04n.svg?react'
import weather_09d from '../icons/weather/09d.svg?react'
import weather_09n from '../icons/weather/09n.svg?react'
import weather_10d from '../icons/weather/10d.svg?react'
import weather_10n from '../icons/weather/10n.svg?react'
import weather_11d from '../icons/weather/11d.svg?react'
import weather_11n from '../icons/weather/11n.svg?react'
import weather_13d from '../icons/weather/13d.svg?react'
import weather_13n from '../icons/weather/13n.svg?react'
import weather_50d from '../icons/weather/50d.svg?react'
import weather_50n from '../icons/weather/50n.svg?react'
import weather_cloudy from '../icons/weather_cloudy.svg?react'
import website from '../icons/website.svg?react'
import x from '../icons/x.svg?react'
import youtube from '../icons/youtube.svg?react'

const icons = {
  arrow_circle: arrow_circle,
  arrow_r: arrow_r,
  arrow: arrow,
  assistant: assistant,
  bed: bed,
  burger: burger,
  calendar_check: calendar_check,
  calendar: calendar,
  camera: camera,
  capacity: capacity,
  chair: chair,
  chat: chat,
  check: check,
  checked: checked,
  chef: chef,
  chevron_down: chevron_down,
  circle_star_inverted: circle_star_inverted,
  circle_star: circle_star,
  clock: clock,
  close: close,
  compass: compass,
  cross: cross,
  cursor: cursor,
  cutlery: cutlery,
  dish: dish,
  district: district,
  door: door,
  download: download,
  drink: drink,
  email: email,
  facebook: facebook,
  flag: flag,
  geolocation: geolocation,
  heart_brown: heart_brown,
  heart_dark: heart_dark,
  heart_solid: heart_solid,
  heart: heart,
  home: home,
  instagram: instagram,
  leaf: leaf,
  linkedin: linkedin,
  man: man,
  map_marker_active: map_marker_active,
  map_marker: map_marker,
  marker: marker,
  mask: mask,
  minus: minus,
  monaco_flag_mini: monaco_flag_mini,
  moon_half: moon_half,
  news: news,
  no_pmr: no_pmr,
  phone: phone,
  plus_map: plus_map,
  plus: plus,
  pmr: pmr,
  podium: podium,
  presentation: presentation,
  search: search,
  share: share,
  star_michelin: star_michelin,
  star: star,
  sun_half: sun_half,
  sun: sun,
  terrace: terrace,
  ticket: ticket,
  tiktok: tiktok,
  weather_01d: weather_01d,
  weather_01n: weather_01n,
  weather_02d: weather_02d,
  weather_02n: weather_02n,
  weather_03d: weather_03d,
  weather_03n: weather_03n,
  weather_04d: weather_04d,
  weather_04n: weather_04n,
  weather_09d: weather_09d,
  weather_09n: weather_09n,
  weather_10d: weather_10d,
  weather_10n: weather_10n,
  weather_11d: weather_11d,
  weather_11n: weather_11n,
  weather_13d: weather_13d,
  weather_13n: weather_13n,
  weather_50d: weather_50d,
  weather_50n: weather_50n,
  weather_cloudy: weather_cloudy,
  website: website,
  x: x,
  youtube: youtube,
}

export default icons
